export const salaryAmountCategories = {
  totalAmountInCoins: "totalAmountInCoins",
  cash: "cash",
  inApp: "inApp",
};

export const defaultNumInUndefined = 0;

export const defaultCashCommission = 0;
